// SavedPaymentMethods.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';


const SavedPaymentMethods = ({ customerId, onCheckSaved }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState('');
  const userData = useSelector(state => state.user)
  
  useEffect(() => {
    if (!customerId) return;
  
    const fetchPaymentMethods = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_PAYMENT_METHODS}${customerId}`);
        const methods = response.data.data;
        setPaymentMethods(methods);
  
        // Let parent know if there's at least one saved card
        if (onCheckSaved) {
          onCheckSaved(methods.length > 0);
        }
  
        // Fetch default payment method
        const customer = await axios.get(`${process.env.REACT_APP_CUSTOMER}${customerId}`);
        const defaultMethod = customer.data.defaultPaymentMethod;
        setDefaultPaymentMethod(defaultMethod);
        setSelectedPaymentMethod(defaultMethod);
      } catch (error) {
        setErrorMessage(error.message);
      }
    };
  
    // Run immediately on mount/update
    fetchPaymentMethods();
  
    // Run every 6 seconds
    const interval = setInterval(fetchPaymentMethods, 6000);
  
    // Cleanup interval on unmount
    return () => clearInterval(interval);
  
  }, [customerId, userData, onCheckSaved]);
  
  

  const handlePrimaryChange = async (event) => {
    const paymentMethodId = event.target.value;
    setSelectedPaymentMethod(paymentMethodId);
    // Set the selected payment method as primary in Stripe
    try {
      await axios.post(`${process.env.REACT_APP_SET_DEFAULT_PAYMENT_METHOD}${customerId}`, {
        paymentMethodId: paymentMethodId
      });
      setDefaultPaymentMethod(paymentMethodId);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="default-payments">
      <h2>Default Payment Method</h2>
      <select value={selectedPaymentMethod} onChange={handlePrimaryChange}>
        {paymentMethods.map((method) => (
          <option key={method.id} value={method.id}>
            {method.card.brand} ending in {method.card.last4} - Expires {method.card.exp_month}/{method.card.exp_year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SavedPaymentMethods;
